// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:01:02.777Z
// Property: Allegro Apartments (ID: 6767906449166423)
// Collections: 35 amenities, 12 floorplans (live), 24 photos, 50 POIs, 5 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166423",
  "property_external_id": "z036qcw",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/allegro-apartments/5XhyD2/",
  "property_apartments_url": "https://www.apartments.com/allegro-apartments-phoenix-az/z036qcw/",
  "property_google_business_url": "https://www.google.com/maps/place/Allegro+Apartments/data=!4m2!3m1!1s0x0:0x1354b3d61490f564?sa=X&ved=2ahUKEwipjcDL4KeSAxXE38kDHeilB6sQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40243710832",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "218ALE",
  "property_status": null,
  "property_slug": "allegro-apartments",
  "property_name": "Allegro Apartments",
  "property_website_url": "https://www.allegro-apts.com/",
  "property_domain": "https://www.allegro-apts.com/",
  "property_address": "4411 East Chandler Boulevard",
  "property_full_address": "4411 E Chandler Blvd, Phoenix, AZ 85048",
  "property_address_1": "4411 E Chandler Blvd",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85048",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Ahwatukee Foothills Village",
  "property_address_latitude": "33.3033585",
  "property_address_longitude": "-111.9883925",
  "property_email": null,
  "property_phone": "(877) 311-7010",
  "property_call_tracking_phone": "844-687-6966",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Allegro, your vibrant oasis in Phoenix, AZ! Choose from our spacious one, two, or three-bedroom apartments, each featuring natural light and modern finishes. Enjoy resort-style amenities like sparkling pools, a fitness center, and a welcoming clubhouse. Start your new chapter—browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Allegro, your serene oasis in the heart of Phoenix, AZ. Choose from our spacious one, two, and three-bedroom apartment floor plans designed to elevate your living experience. Each home is appointed with modern amenities, abundant natural light, and stunning features such as quartz countertops, stainless steel appliances, and large walk-in closets.\n\nAt Allegro, we pride ourselves on providing an exceptional lifestyle. Take a dip in one of our two sparkling pools and unwind in the jacuzzi, or energize your day in our state-of-the-art fitness center. Our inviting clubhouse lounge is perfect for entertaining friends or engaging in community-sponsored activities. Enjoy the convenience of on-site services including copy/fax capabilities, parcel lockers, and reserved parking options, all designed to simplify your life.\n\nNestled in a gated community with easy freeway access, Allegro boasts a prime location near shopping, dining, and entertainment. Enjoy the convenience of guest parking, responsive on-site maintenance, and professional management. Your comfort is further enhanced with amenities like air conditioning, ceiling fans, and in-unit washers and dryers, ensuring you have everything you need at your fingertips.\n\nTake advantage of our private patios and balconies with storage closets, where you can relax and enjoy the beautiful Arizona weather. With countless windows allowing for ample natural light, your new home is designed for comfort and livability.\n\nFind your new home today – browse our availability or schedule a tour to visit our vibrant community at Allegro! Don’t miss your chance to make this wonderful living experience your own.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-a43c-716d-b8fc-628b6ce1ee96.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "019f6699-a43c-716d-b8fc-628b6ce1ee96",
    "storage_key": "property/6767906449166423/019f6699-a43c-716d-b8fc-628b6ce1ee96.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166423/019ffc38-e291-7647-a762-9b250e9a8fc9.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc38-e291-7647-a762-9b250e9a8fc9",
    "storage_key": "property/6767906449166423/019ffc38-e291-7647-a762-9b250e9a8fc9.m4v",
    "thumbnail_key": "property/6767906449166423/019ffc38-e291-7647-a762-9b250e9a8fc9_thumb.webp",
    "size_bytes": 17756017,
    "classification": "Community",
    "title": "Explore Our Apartment Community: Pool, Gym, and Modern Interiors",
    "description": "Discover the vibrant lifestyle and amenities offered at our apartment community, featuring a sparkling pool, state-of-the-art gym, and beautifully appointed interiors. Tour our facilities and envision your new home."
  },
  "property_total_units": "264",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.53030303030303",
  "property_admin_fee": "300",
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$300-1 month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Maximum 2 pets per apartment. Dogs limited to 75 lb. Aggressive breed restrictions apply (e.g., Akita, American Bulldog, Bull/Brazilian Mastiff, Bull Terrier, Boxer, Chow Chow, Dalmatian, Doberman, German Shepherd, Shiba Inu, Great Dane, Pitbull/Stafford Terriers, Rottweiler, Rhodesian Ridgeback, Husky/Malamute/Samoyed, Shar Pei). Exceptions may be made for service animals or emotional support animals.",
  "property_pet_policy_description": "Dogs or cats welcome. Maximum 2 pets per apartment. $300 non‑refundable pet fee. $35 monthly pet rent per pet. Dogs limited to 75 lb. Aggressive breed restrictions apply (e.g., Akita, American Bulldog, Bull/Brazilian Mastiff, Bull Terrier, Boxer, Chow Chow, Dalmatian, Doberman, German Shepherd, Shiba Inu, Great Dane, Pitbull/Stafford Terriers, Rottweiler, Rhodesian Ridgeback, Husky/Malamute/Samoyed, Shar Pei). Exceptions may be made for service animals or emotional support animals.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://allegro.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcallegro",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c9-5143-743e-ac1f-60a652e60d58.webp",
  "property_primary_logo_media": {
    "alt_text": "Allegro Luxury Apartments logo",
    "public_id": "019d02c9-5143-743e-ac1f-60a652e60d58",
    "storage_key": "property/6767906449166423/019d02c9-5143-743e-ac1f-60a652e60d58.webp",
    "width": 239,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c9-3dbc-7364-8651-0105b91e2fea.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c9-3dbc-7364-8651-0105b91e2fea",
    "storage_key": "property/6767906449166423/019d02c9-3dbc-7364-8651-0105b91e2fea.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c9-6117-7690-b104-8e417644a2b8.webp",
  "property_icon_media": {
    "alt_text": "Repli logo",
    "public_id": "019d02c9-6117-7690-b104-8e417644a2b8",
    "storage_key": "property/6767906449166423/019d02c9-6117-7690-b104-8e417644a2b8.webp",
    "width": 640,
    "height": 314
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c9-6d4b-704f-9e90-cce614d69bb1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Allegro Luxury Apartments logo",
    "public_id": "019d02c9-6d4b-704f-9e90-cce614d69bb1",
    "storage_key": "property/6767906449166423/019d02c9-6d4b-704f-9e90-cce614d69bb1.webp",
    "width": 239,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c9-5143-743e-ac1f-60a652e60d58.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Allegro Luxury Apartments logo",
    "public_id": "019d02c9-5143-743e-ac1f-60a652e60d58",
    "storage_key": "property/6767906449166423/019d02c9-5143-743e-ac1f-60a652e60d58.webp",
    "width": 239,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "684 - 1334",
  "property_sqft_min": "684",
  "property_sqft_max": "1334",
  "property_price_range": null,
  "property_price_min": "1469",
  "property_price_max": null,
  "property_available_units": 25,
  "property_facebook_url": "https://www.facebook.com/AllegroAZ/",
  "property_instagram_url": "https://www.instagram.com/allegrophx/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJl4j0gmUEK4cRZPWQFNazVBM",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=the+park&find_loc=E+Ray+Rd+%26+S+48th+St%2C+Phoenix%2C+AZ+85044",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Allegro",
  "property_home_romance_title": "Embrace Life Together in Your New Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Allegro, where modern living meets comfort in the heart of Phoenix. Choose from spacious one, two, and three-bedroom apartment homes featuring stainless steel appliances and private balconies. Dive into luxury with our sparkling pools, stay fit in our fully-equipped fitness center, and enjoy vibrant community activities.",
  "property_home_floorplans_blurb": "Welcome to Allegro in vibrant Phoenix, AZ, where spacious and stylish living awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Don’t just dream of the perfect home—embrace it. Browse our available apartment homes today and elevate your living experience!",
  "property_home_gallery_blurb": "Welcome to Allegro, an inviting oasis in vibrant Phoenix, AZ. Choose from spacious one, two, or three-bedroom floor plans featuring modern amenities like sparkling pools, a fitness center, and private patios. With professional management and a prime location near shopping and dining, picture your ideal lifestyle unfolding here!",
  "property_home_neighborhood_blurb": "At Allegro in Phoenix, experience a vibrant lifestyle surrounded by nature and adventure. Enjoy easy access to South Mountain Park trails, unwind at Oasis Water Park, or ignite your thrill-seeking side at Urban Air Trampoline Park. Live where excitement and leisure seamlessly blend—your ideal home awaits!",
  "property_home_reviews_blurb": "Welcome to Allegro, where peaceful living meets urban convenience in Phoenix! Our residents rave, \"I love the place, the people, and everything.\" Enjoy beautiful amenities, a pet-friendly atmosphere, and seamless access to shopping and downtown. Experience community events and unparalleled staff support—your perfect oasis awaits!",
  "property_neighborhood_blurb": "Embrace a vibrant lifestyle at Allegro in Phoenix, AZ! Nestled near outdoor adventures like South Mountain Park and Preserve and Desert Breeze Park, our community places you close to nature and excitement. With dynamic attractions like SEA LIFE Arizona Aquarium and Urban Air Trampoline Park, there’s always something thrilling to experience! See what's around our community and explore local favorites and nearby points of interest.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Allegro in sunny Phoenix, AZ, where comfort meets convenience! Choose from stylish one, two, or three-bedroom apartments adorned with modern finishes. Dive into our sparkling pools, energize at the fitness center, or unwind on your private patio. Life here is vibrant and full of opportunities for relaxation and connection. ",
  "property_applynow_blurb": "At Allegro in vibrant Phoenix, AZ, your ideal living space awaits with spacious one, two, and three-bedroom floor plans. Indulge in our two sparkling pools and fitness center, or unwind on your private balcony. With top-notch amenities and professional management, make Allegro your perfect new home today!",
  "property_contactus_blurb": "At Allegro in sunny Phoenix, AZ, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Whether you seek a cozy retreat or a spacious haven, we have the ideal space for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "<p>Have questions? We've got answers. Whether you're curious about floor plans, pet policies, or community amenities, we've put together answers to the questions we hear most at Allegro. Don't see what you're looking for? Contact us or stop by, we'd love to show you around. At Allegro in vibrant Phoenix, AZ, we offer a variety of spacious floor plans, including one, two, and three-bedroom apartments designed for your comfort. Curious about our community? Visit our FAQs page to uncover the answers to your most pressing questions and see why Allegro is the perfect place to call home.</p>",
  "property_floorplans_blurb": "At Allegro in vibrant Phoenix, AZ, our thoughtfully designed floor plans cater to every lifestyle with one, two, and three-bedroom options. Each home seamlessly blends comfort and style, inviting you to experience modern living. Browse our available apartment homes and uncover the perfect space to call your own!",
  "property_gallery_blurb": "At Allegro in vibrant Phoenix, AZ, we offer spacious one, two, and three-bedroom apartments designed for modern living. Picture yourself in a tranquil setting, surrounded by lush landscaping, sparkling pools, and a welcoming clubhouse. With breathtaking views and stylish finishes, your ideal home awaits—don’t just imagine it, live it!",
  "property_interactivemap_blurb": "Welcome to Allegro, where modern living meets vibrant community in the heart of Phoenix, AZ. Choose from spacious one, two, or three-bedroom floor plans with luxurious amenities like sparkling pools, a fitness center, and stylish interiors. Navigate our interactive map to find your ideal apartment and elevate your lifestyle today!",
  "property_pets_blurb": "At Allegro in vibrant Phoenix, AZ, your furry friends are part of the family! Enjoy spacious apartments with a welcoming atmosphere, perfect for you and your pets. With a few breed restrictions and a low pet fee, you'll feel right at home while creating unforgettable memories together.",
  "property_referafriend_blurb": "At Allegro in sunny Phoenix, AZ, we offer spacious one, two, and three-bedroom floor plans ideal for every lifestyle. Share the joy of living in our vibrant community—great friends make great neighbors! Refer a friend today and help them find their perfect home at Allegro!",
  "property_residentaccess_blurb": "Welcome to Allegro in vibrant Phoenix, AZ, where comfort meets convenience. Whether you're seeking a cozy one-bedroom hideaway or a spacious three-bedroom sanctuary, our diverse floor plans cater to your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy the best of apartment living!",
  "property_reviews_blurb": "At Allegro in Phoenix, residents rave about their vibrant community and exceptional amenities. As one tenant gleefully shared, \"This place is everything I imagined it would be!\" With a pet-friendly environment, friendly staff, and a stunning pool, Allegro perfectly combines comfort and convenience. Join us and experience the allure of upscale apartment living!",
  "property_created_at": "1759782534313",
  "property_scheduletour_blurb": "At Allegro in vibrant Phoenix, AZ, find your ideal home with our thoughtfully designed one, two, and three-bedroom floor plans. Each space harmonizes comfort and style, perfect for today’s lifestyle. Curious about our community? Schedule a tour today and see what our residents love about living here!",
  "property_thankyou_blurb": "Thank you for reaching out to Allegro in sunny Phoenix, AZ! We're excited to help you find your perfect home among our diverse floor plans, including one, two, and three bedrooms. Stay tuned—one of our friendly team members will connect with you shortly to assist with your journey.",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at Allegro in sunny Phoenix, AZ. Choose from spacious one, two, or three-bedroom apartment floor plans tailored to your needs. Immerse yourself in our community’s charm and modern amenities—take a virtual tour today and find your perfect home at Allegro!",
  "property_copyright": "2025 All Rights Reserved. Allegro",
  "property_seo_title_home": "Apartments in Phoenix, AZ | Allegro",
  "property_seo_description_home": "Allegro is a luxury apartment living Community with pet-friendly 1, 2 & 3-Bedroom apts for rent in Phoenix, AZ. Contact us today!",
  "property_seo_title_floorplans": "Floor Plans | Luxury 1, 2 & 3-Bedroom Apts in Phoenix, AZ",
  "property_seo_description_floorplans": "Explore 1, 2 & 3-Bedroom apts at Allegro in Phoenix. Two sparkling swimming pools, a jacuzzi, and a fitness center await.",
  "property_seo_title_amenities": "Amenities | Phoenix Apartments With Sparkling Swimming Pools",
  "property_seo_description_amenities": "Enjoy two sparkling swimming pools and a hot tub at Allegro in Phoenix, AZ. Pet-friendly living made easy.",
  "property_seo_title_gallery": "Gallery | Luxury Apartments For Rent in Phoenix, AZ",
  "property_seo_description_gallery": "View photos of Allegro in Phoenix, AZ. See stylish floor plans, luxury amenities, and pet-friendly community spaces.",
  "property_seo_title_virtualtours": "Virtual Tour | Luxury Pet-Friendly Apartments in Phoenix, AZ",
  "property_seo_description_virtualtours": "Embark on a virtual journey at Allegro! Explore our pet-friendly 1, 2 & 3-Bedroom apts in Phoenix, AZ, through our virtual tours.",
  "property_seo_title_interactivemap": "Interactive Map | Phoenix Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at Allegro in Phoenix! Explore our spacious 1-3 bedroom homes with top amenities and an interactive map to find your dream apartment.",
  "property_seo_title_neighborhood": "Neighborhood | Luxury Apts Near The Desert Botanical Garden",
  "property_seo_description_neighborhood": "Live close to The Desert Botanical Garden and Chase Field at Allegro with luxury apartments designed for your comfort and convenience.",
  "property_seo_title_contact": "Contact Us | Phoenix Apartments Near Chase Field",
  "property_seo_description_contact": "Contact Allegro today to schedule a tour. Discover 1, 2 & 3-Bedroom apts with modern features in Phoenix with easy freeway access..",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Find answers to your questions about life at Allegro in Phoenix, AZ. Discover amenities, floor plans, and more as you explore our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Experience vibrant living at Allegro in Phoenix! Read what our residents love about their spacious homes, stunning amenities, and inviting community vibe!",
  "property_seo_title_applynow": "Apply Now | 2 Bedroom Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Ready to make Allegro your new home? Apply online for our 1, 2 & 3-Bedroom apts in Phoenix and start your journey today!",
  "property_seo_title_residentaccess": "Resident Access | Luxury One Bedroom Units",
  "property_seo_description_residentaccess": "At Allegro, our resident portal offers seamless 24/7 access, simplifying maintenance requests and online rent payments for your convenience.",
  "property_seo_title_referafriend": "Refer A Friend | Allegro",
  "property_seo_description_referafriend": "Refer a friend to Allegro in Phoenix, AZ! Great friends make great neighbors—share the joy of apartment living and enjoy exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments With a Jacuzzi",
  "property_seo_description_scheduletour": "Excited to explore Allegro in person? Arrange a tour to discover our amenities and open-concept apartment designs in Phoenix, AZ!",
  "property_seo_title_privacy": "Privacy Policy | Allegro",
  "property_seo_description_privacy": "At Allegro Phoenix, we prioritize your peace of mind. Review our privacy policy to see how we protect your information and ensure security.",
  "property_seo_title_accessibility": "Website Accessibility | Allegro",
  "property_seo_description_accessibility": "At Allegro in Phoenix, we prioritize accessibility and digital inclusion for all. Join our vibrant community where everyone feels at home. Learn more today!",
  "property_seo_title_sitemap": "Sitemap | Allegro",
  "property_seo_description_sitemap": "Explore Allegro in Phoenix, AZ! Use our sitemap for quick access to amenities, floor plans, and all our vibrant community has to offer!",
  "property_seo_title_thankyou": "Thank You | Lease Allegro Apartments in Arizona",
  "property_seo_description_thankyou": "Thank you for your interest in Allegro Apartments. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | 1 Bedroom Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786643019047",
  "amenities": [
    {
      "id": "custom_35ec2a53-d3e1-45b5-8c59-5f73c0056180",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "2 Sparkling Pools with Jacuzzi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_df17002c-ff82-43c3-b397-08f031bcdb86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7281be97-dc75-41a0-8e72-b7ee74695d6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse lounge for entertaining and community-sponsored activities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_04f1fa82-3561-4d20-b92c-98fe6619c93b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Freeway Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a9655aeb-789c-4761-8b92-8e4730902230",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1b9e6213-72d6-45be-a8c3-527ff8d05918",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_368505cc-2899-453c-be27-f241a544f03e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_442ea41f-dcf4-40ef-a8e9-abe1aab378b7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Resident BBQ Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0ada76ce-d0cd-4799-bc79-2273f2fe59fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Parcel Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_adf3b1f1-e5b8-40e3-b9b6-c4db8ee17203",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi access available in all units and public spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_16d96378-1a6d-4517-8a26-a86bf28e04ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_dd1fcd36-a5aa-4068-a6f8-4d6cd1bc9233",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1be68815-44b1-4e25-a773-643826fd1920",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fd8924e2-f2fa-4b72-b177-3b81f120f3c7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Near Shopping, Dining, and Entertainment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_96fd71cc-ec0a-4b3c-9284-f685f95648b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "A Multitude of Windows for Natural Light",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_45c92182-a00c-49a2-925d-6573a671f1b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Private patios and balconies with storage closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_202fbdb1-746f-42aa-930d-224ed25d2245",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Cable/Satellite Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7dd203bb-122e-40a7-a455-8ac044c175a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4ddc2b9f-7b34-46a4-9a07-c563d3b96c17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3a3ca86f-a703-4f40-96d2-4ab8d2d0ec96",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0d916d63-3947-4840-a374-08ebd9824cea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ac8e5ee7-75e7-4a86-b3c4-b73e3b0c90d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e057e3b2-c207-46ec-9657-be08fbc7720c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ade20948-fd20-4df7-b4ce-31d3a54d7f5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5249056f-b983-49aa-b01b-f06d48dec2de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Conventional Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4db2e5b9-ccae-4273-93e8-3c3a52abb295",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_916d4eb1-258e-4ee4-9af1-009652874fbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Garages",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4bdf13c5-c984-4582-abde-0f4df1f56dbc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Woodgrain Vinyl Flooring in Select Units",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_375a7a01-d701-4349-bf37-fee3d41621ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Garden Style Tubs*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ab881c86-63c7-4d3e-a367-ff24f392baf7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cb8f8245-32c8-442a-963b-4d7446b097ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Private storage areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6b6ee346-cb50-416b-b5fe-6224175bd020",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b8b65a9c-9777-4788-8d7e-579a040123ae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk-in Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cd6437f2-11de-4a93-b680-a74b8dbff9d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer in Unit",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_84fc6be0-e727-446b-8027-188b892a1c82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_54c33a76-2d81-41df-80ae-9a6c7dc5e05c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-03f4-76f7-8a6a-5a6ca1ba74d1.webp",
      "image_media": {
        "alt_text": "Allegro Luxury Apartments leasing office and monument sign.",
        "public_id": "01a01106-03f4-76f7-8a6a-5a6ca1ba74d1",
        "storage_key": "property/6767906449166423/01a01106-03f4-76f7-8a6a-5a6ca1ba74d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The leasing office and exterior of Allegro Luxury Apartments, featuring a welcoming entrance and clear signage.",
      "link": "",
      "alt_text": "Allegro Luxury Apartments leasing office and monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6739ba6-5b73-4cfc-a16f-0ef307b2a905",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-088f-76c3-b1cf-0934fbc97fc3.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and exterior staircases at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01106-088f-76c3-b1cf-0934fbc97fc3",
        "storage_key": "property/6767906449166423/01a01106-088f-76c3-b1cf-0934fbc97fc3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with balconies, staircases, and manicured landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment building with balconies and exterior staircases at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a5a100a-debb-4b08-90b6-5a25cbaddb3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-51cf-731f-9aa9-31f8e4147b54.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs visible at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01106-51cf-731f-9aa9-31f8e4147b54",
        "storage_key": "property/6767906449166423/01a01106-51cf-731f-9aa9-31f8e4147b54.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable seating areas.",
      "link": "",
      "alt_text": "Apartment complex courtyard with a swimming pool and lounge chairs visible at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_197f445a-8579-4fc5-b637-e8582aa186e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-2277-7100-b8f8-30a60f81b3cb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building 2 with balconies and surrounding green lawn at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01106-2277-7100-b8f8-30a60f81b3cb",
        "storage_key": "property/6767906449166423/01a01106-2277-7100-b8f8-30a60f81b3cb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior of apartment building 2, featuring private balconies and lush green landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment building 2 with balconies and surrounding green lawn at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c208e27-7248-4813-a949-64c6e7f9f665",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-45f8-760b-9f18-251634429581.webp",
      "image_media": {
        "alt_text": "Row of garage doors with numbers above them at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01106-45f8-760b-9f18-251634429581",
        "storage_key": "property/6767906449166423/01a01106-45f8-760b-9f18-251634429581.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure your vehicle and belongings in our convenient garage spaces, offering ample storage and protection.",
      "link": "",
      "alt_text": "Row of garage doors with numbers above them at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fbc1eea-2da0-4596-baca-213f8f1a0bd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-4708-71d1-9cb2-cd6b3c6d9f38.webp",
      "image_media": {
        "alt_text": "Spacious, well-lit community lounge with modern furniture and large windows overlooking the pool area.",
        "public_id": "01a01106-4708-71d1-9cb2-cd6b3c6d9f38",
        "storage_key": "property/6767906449166423/01a01106-4708-71d1-9cb2-cd6b3c6d9f38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating and stunning views of the resort-style pool.",
      "link": "",
      "alt_text": "Spacious, well-lit community lounge with modern furniture and large windows overlooking the pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_534164e2-3e32-4a4b-a29f-8984f12ca6f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-594f-71fe-8e4b-bca9cc7fcd18.webp",
      "image_media": {
        "alt_text": "Modern dining area with a high table and stools, artwork, and plants at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01106-594f-71fe-8e4b-bca9cc7fcd18",
        "storage_key": "property/6767906449166423/01a01106-594f-71fe-8e4b-bca9cc7fcd18.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a stylish dining experience in our modern community space, featuring a high-top table, comfortable stools, and tasteful decor.",
      "link": "",
      "alt_text": "Modern dining area with a high table and stools, artwork, and plants at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99267f6e-e66a-4020-8497-fce3fa35ba01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-86b7-7223-a577-f15898c1b528.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, stair climber, elliptical, and weight machines at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-86b7-7223-a577-f15898c1b528",
        "storage_key": "property/6767906449166423/01a01105-86b7-7223-a577-f15898c1b528.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern gym with treadmills, stair climber, elliptical, and weight machines at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0cd19f86-942f-4a8d-af07-a444a429e11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-46c5-75fe-a0d8-3ecd53d51ccc.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "01a01105-46c5-75fe-a0d8-3ecd53d51ccc",
        "storage_key": "property/6767906449166423/01a01105-46c5-75fe-a0d8-3ecd53d51ccc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool and spa, surrounded by comfortable lounge chairs and lush landscaping. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a spa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8d7fa8d-ba0f-4568-8e07-92cd5a28686a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-661f-75d0-bddc-640f32d41319.webp",
      "image_media": {
        "alt_text": "Apartment complex with a sparkling blue swimming pool and lounge chairs in the foreground at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-661f-75d0-bddc-640f32d41319",
        "storage_key": "property/6767906449166423/01a01105-661f-75d0-bddc-640f32d41319.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Apartment complex with a sparkling blue swimming pool and lounge chairs in the foreground at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f25fdae-5391-4a24-890f-80a98b8e86fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-bcd9-711d-9583-098502084f28.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a cabana at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-bcd9-711d-9583-098502084f28",
        "storage_key": "property/6767906449166423/01a01105-bcd9-711d-9583-098502084f28.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate comfort.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a cabana at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f347ff8e-cb9b-43d4-bb54-51212b48bbf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-6a49-76e8-aaf2-34b732b01156.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a01105-6a49-76e8-aaf2-34b732b01156",
        "storage_key": "property/6767906449166423/01a01105-6a49-76e8-aaf2-34b732b01156.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful apartment buildings. Your oasis awaits.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_614c92fd-0285-4995-8a95-2bc77db280c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-c252-76de-927c-e8b6a0684ea1.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with stainless steel grill, counter space, trash cans, and seating near a swimming pool.",
        "public_id": "01a01105-c252-76de-927c-e8b6a0684ea1",
        "storage_key": "property/6767906449166423/01a01105-c252-76de-927c-e8b6a0684ea1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy convenient outdoor cooking at our built-in gas grill station, complete with ample counter space and nearby seating, perfect for poolside gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling station with stainless steel grill, counter space, trash cans, and seating near a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8124b63-b29b-4dfc-a92a-f630c0a77de6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-daea-75de-8da6-410d56956a3d.webp",
      "image_media": {
        "alt_text": "Covered patio area with seating and outdoor umbrell at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-daea-75de-8da6-410d56956a3d",
        "storage_key": "property/6767906449166423/01a01105-daea-75de-8da6-410d56956a3d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the shaded patio area, featuring comfortable seating and a large umbrella for sunny days.",
      "link": "",
      "alt_text": "Covered patio area with seating and outdoor umbrell at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5bb63798-6114-4e91-8f15-a5ccd260e256",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-9dbb-736e-bc77-d412feda7cf9.webp",
      "image_media": {
        "alt_text": "Amazon package lockers in a hallway",
        "public_id": "01a01105-9dbb-736e-bc77-d412feda7cf9",
        "storage_key": "property/6767906449166423/01a01105-9dbb-736e-bc77-d412feda7cf9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure Amazon package lockers are available for residents, offering convenient and safe package delivery.",
      "link": "",
      "alt_text": "Amazon package lockers in a hallway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03be7318-bf85-412a-987e-a1926ac2431e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-0845-70ec-a8e2-7f19e0226a46.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured grass and walkways.",
        "public_id": "01a01106-0845-70ec-a8e2-7f19e0226a46",
        "storage_key": "property/6767906449166423/01a01106-0845-70ec-a8e2-7f19e0226a46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with well-maintained apartment buildings create a welcoming atmosphere for residents.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured grass and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7158cfdd-8c68-4399-a61c-287c4856c438",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-6ac6-74da-8cc4-74e853e1de12.webp",
      "image_media": {
        "alt_text": "Kitchen with island and seating at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-6ac6-74da-8cc4-74e853e1de12",
        "storage_key": "property/6767906449166423/01a01105-6ac6-74da-8cc4-74e853e1de12.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, a large island with seating, and ample cabinet space.",
      "link": "",
      "alt_text": "Kitchen with island and seating at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2bb07d8-7fee-48c9-a02d-a42bd7286bb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-80f6-72cd-8373-6340aea6d257.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-80f6-72cd-8373-6340aea6d257",
        "storage_key": "property/6767906449166423/01a01105-80f6-72cd-8373-6340aea6d257.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2968d6f1-246d-40ac-96a3-ff607e7a3ce2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-b8e4-73e9-b7da-8b1fe263265e.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, blue accent chair, and TV.",
        "public_id": "01a01105-b8e4-73e9-b7da-8b1fe263265e",
        "storage_key": "property/6767906449166423/01a01105-b8e4-73e9-b7da-8b1fe263265e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living room featuring a comfortable white sofa, a stylish blue accent chair, and a modern entertainment center with a TV. Large windows allow ample natural light, offering views of the surrounding greenery.",
      "link": "",
      "alt_text": "Living room with a white sofa, blue accent chair, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f498a93d-f9b4-4da8-b186-35b0b8693a7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-c3b6-77c7-a56d-650f3111d5c5.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a couch, chairs, and a tabel at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-c3b6-77c7-a56d-650f3111d5c5",
        "storage_key": "property/6767906449166423/01a01105-c3b6-77c7-a56d-650f3111d5c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy living and dining area with modern furniture and elegant finishes.",
      "link": "",
      "alt_text": "Living room and dining area with a couch, chairs, and a tabel at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_184f0d61-45aa-40e4-bf9d-74caa5772e09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-f2bb-727f-9387-6e229ce26383.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and desk with a chair at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-f2bb-727f-9387-6e229ce26383",
        "storage_key": "property/6767906449166423/01a01105-f2bb-727f-9387-6e229ce26383.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, modern nightstand, and a convenient desk area, perfect for work or study.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and desk with a chair at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6733ac5-fb92-45f4-8e34-ad3a3f53ba9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-dfa7-74e8-8890-1a7435af59df.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, mirror, and a glass-enclosed shower and tub.",
        "public_id": "01a01105-dfa7-74e8-8890-1a7435af59df",
        "storage_key": "property/6767906449166423/01a01105-dfa7-74e8-8890-1a7435af59df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom featuring a spacious vanity with ample counter space, a large mirror, and a separate shower and tub area. Perfect for relaxation and rejuvenation.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, mirror, and a glass-enclosed shower and tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e706d2a-f43b-453e-8272-e04d09fa7644",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01105-cfa9-732b-b3a9-de10635c1c82.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a sliding glass door leading to a balcony at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01105-cfa9-732b-b3a9-de10635c1c82",
        "storage_key": "property/6767906449166423/01a01105-cfa9-732b-b3a9-de10635c1c82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly appointed bedroom featuring a comfortable king-size bed, stylish nightstands with lamps, and a private balcony accessible through a sliding glass door.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a sliding glass door leading to a balcony at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4132cce-7a70-4422-92e8-b2ac08d15d1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/01a01106-00ee-743e-af94-913a6a8ca903.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a small table outside an apartment unit at Allegro in vibrant Phoenix, AZ.",
        "public_id": "01a01106-00ee-743e-af94-913a6a8ca903",
        "storage_key": "property/6767906449166423/01a01106-00ee-743e-af94-913a6a8ca903.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, complete with comfortable seating and a stylish side table. A perfect extension of your living space.",
      "link": "",
      "alt_text": "Balcony with two chairs and a small table outside an apartment unit at Allegro in vibrant Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f883250e-f0b7-401f-8552-4e69dbe5de36",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Chandler Fashion Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3111 W Chandler Blvd, Chandler, AZ 85226, USA",
      "poi_short_description": "Upscale mall with a large variety of retailers, a food court, and a cinema.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including high-end brands and budget-friendly options, as well as a diverse food court with fast food and casual dining options. They highlight the spacious, clean, and well-maintained environment, and the ample parking. They also like the friendly and helpful staff, and the secure atmosphere with visible security.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-7995-76b4-a4c2-68eb9e03e53b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-7995-76b4-a4c2-68eb9e03e53b",
        "storage_key": "property/6767906449166423/019d02c7-7995-76b4-a4c2-68eb9e03e53b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopchandlerfashioncenter.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16948311328882979246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chandler-fashion-center",
      "poi_latitude": "33.3014708",
      "poi_longitude": "-111.8984985",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-812-8488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5ac-70de-a1e6-fac6f329e8ef",
        "storage_key": "property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzevPCdQAK4cRrnHMjFt_NOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cde528fd-c7ed-480e-9b9e-10816cb199c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Phoenix Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "4976 Premium Outlets Way, Chandler, AZ 85226, USA",
      "poi_short_description": "Casual, outdoor retailer featuring more than 90 outlet stores for brands like Adidas, Nike, and Coach.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores, including clothing, shoes, and purses, with many brands and deals. They highlight the clean and inviting atmosphere, with shaded areas, water features, and a food court with several restaurants. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-7e07-7759-873e-d00d40df35e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-7e07-7759-873e-d00d40df35e4",
        "storage_key": "property/6767906449166423/019d02c7-7e07-7759-873e-d00d40df35e4.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/phoenix",
      "poi_directions_map_url": "https://maps.google.com/?cid=389775038611643144&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-premium-outlets",
      "poi_latitude": "33.287704",
      "poi_longitude": "-111.9734187",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-639-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5ac-70de-a1e6-fac6f329e8ef",
        "storage_key": "property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhZhPivQDK4cRCNvCHlXCaAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5808bf2e-ed98-4c4f-ac87-859c4420c751",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "South Mountain Community College",
      "poi_type": "Education",
      "poi_address": "7050 S 24th St, Phoenix, AZ 85042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-7e81-730e-b7bd-042b8db37145.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-7e81-730e-b7bd-042b8db37145",
        "storage_key": "property/6767906449166423/019d02c7-7e81-730e-b7bd-042b8db37145.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.southmountaincc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10839400644532731056&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-mountain-community-college",
      "poi_latitude": "33.381761",
      "poi_longitude": "-112.0322335",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-243-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5af-744a-89d8-65e7f50a6e10",
        "storage_key": "property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD6bj0O4PK4cRsHyD43RJbZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_82176108-d60c-4cf5-bf1a-76032476a878",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Chandler Public Library - Sunset",
      "poi_type": "Education",
      "poi_address": "4930 W Ray Rd, Chandler, AZ 85226, USA",
      "poi_short_description": "Area branch offering resources and programs for all ages in a clean space with welcoming staff.",
      "poi_long_description": "People say this public library offers a wide selection of books and other materials, as well as a summer reading program. They highlight the clean and comfortable facility, and the quiet atmosphere. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8073-7074-b310-9e16b61033bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8073-7074-b310-9e16b61033bd",
        "storage_key": "property/6767906449166423/019d02c7-8073-7074-b310-9e16b61033bd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.chandlerlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3559471002777133269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chandler-public-library---sunset",
      "poi_latitude": "33.3211914",
      "poi_longitude": "-111.9251394",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-782-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5af-744a-89d8-65e7f50a6e10",
        "storage_key": "property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYz9FTcAGK4cR1aDVpATIZTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_38f7eaa8-841a-4f81-a51e-a16ea273af17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1616 W Ruby Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "Family-friendly athletic club offering a fitness floor, studio classes, indoor and outdoor pools, plus a spa and kids’ programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-87b6-74c9-bdba-c7839b1448c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-87b6-74c9-bdba-c7839b1448c8",
        "storage_key": "property/6767906449166423/019d02c7-87b6-74c9-bdba-c7839b1448c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/tempe.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=2681829493569576902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.3413432",
      "poi_longitude": "-111.9643591",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-705-8855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB99P-80FK4cRxl9hKLfFNyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87867ce1-72c6-45c3-8d2c-a215904b64b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1727 W Ranch Rd, Tempe, AZ 85284, USA",
      "poi_short_description": "Busy fitness club featuring cardio machines, free weights and group classes like yoga.",
      "poi_long_description": "Visitors say this gym offers a wide variety of equipment, including stand-up benches, and amenities like a sauna, hot spa, and pool. They also highlight the friendly and helpful staff, and the clean facilities.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8804-749e-b846-7946e15e05b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8804-749e-b846-7946e15e05b2",
        "storage_key": "property/6767906449166423/019d02c7-8804-749e-b846-7946e15e05b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/tempe-warner-gym/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16538849712268223417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.3324966",
      "poi_longitude": "-111.9687271",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-660-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRytubMFK4cRuaNRzS_MheU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_34ad06e4-fba5-4c5f-9eff-c799a711fd65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Veterinary Emergency Group",
      "poi_type": "Health and Wellness",
      "poi_address": "7210 W Ray Rd, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8c89-744b-b585-f4d6eb22797a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8c89-744b-b585-f4d6eb22797a",
        "storage_key": "property/6767906449166423/019d02c7-8c89-744b-b585-f4d6eb22797a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.veterinaryemergencygroup.com/locations/arizona/chandler/?utm_source=google&utm_medium=organic&utm_campaign=google_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8376195570769060558&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-emergency-group",
      "poi_latitude": "33.3214268",
      "poi_longitude": "-111.9667345",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-847-2570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJySuAH_4FK4cRzuLjHH45PnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_577c4ef7-a652-4f7b-8f4d-070734f0c427",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1405 W Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including treadmills, machines, and stretching areas. They highlight the clean facilities, including bathrooms and showers, and the calm, quiet vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8cb2-7069-a020-0de6eac08cb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8cb2-7069-a020-0de6eac08cb1",
        "storage_key": "property/6767906449166423/019d02c7-8cb2-7069-a020-0de6eac08cb1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tempe-west-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=970250295572052508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.3915874",
      "poi_longitude": "-111.9616033",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-219-8281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3YnsU8PK4cRHDrK0oAFdw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6de5bcee-535b-481a-bc62-fd9974d01206",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Mountainside Fitness Ahwatukee",
      "poi_type": "Health and Wellness",
      "poi_address": "4820 E Ray Rd, Phoenix, AZ 85044, USA",
      "poi_short_description": "Clean, kid-friendly gym chain featuring a basketball court and 80+ classes for yoga and cardio.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes, including yoga, cycling, and strength training, as well as a sauna, steam room, and smoothies. They highlight the clean facilities, well-maintained equipment, and spacious layout, and like the supportive and energetic community. They also mention the staff is friendly, helpful, and welcoming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8cf0-7268-9932-7a92a2f7ffc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8cf0-7268-9932-7a92a2f7ffc9",
        "storage_key": "property/6767906449166423/019d02c7-8cf0-7268-9932-7a92a2f7ffc9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/ahwatukee/?utm_source=GMB&utm_medium=Local&utm_campaign=Ahwatukee&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=15253796335313761493&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-ahwatukee",
      "poi_latitude": "33.3211189",
      "poi_longitude": "-111.9788696",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-633-2574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE62Ts0cEK4cR1TSI6vJesNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_40936911-0764-411a-9454-e4fb1ffbeaec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "7131 W Ray Rd #12, Chandler, AZ 85226, USA",
      "poi_short_description": "Chain retailer featuring cosmetics, fragrances, and skincare products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8a6c-726b-b10f-dc7ba39e2e25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8a6c-726b-b10f-dc7ba39e2e25",
        "storage_key": "property/6767906449166423/019d02c7-8a6c-726b-b10f-dc7ba39e2e25.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/chandler-az-434",
      "poi_directions_map_url": "https://maps.google.com/?cid=8023896856995626464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "33.3181398",
      "poi_longitude": "-111.9666945",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-753-7076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUc2xLCMEK4cR4P2Y062bWm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_a184e8fe-890d-4d56-95aa-0687427880f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Protea Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "850 W Elliot Rd Suite 101, Tempe, AZ 85284, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-8f80-7417-a4b8-f8aa2cee3f09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8f80-7417-a4b8-f8aa2cee3f09",
        "storage_key": "property/6767906449166423/019d02c7-8f80-7417-a4b8-f8aa2cee3f09.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://protealife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14381833552193812008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "protea-medical-center",
      "poi_latitude": "33.3496088",
      "poi_longitude": "-111.9519231",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-557-9095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a96f-77c1-ac50-43eb0cb76f5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a96f-77c1-ac50-43eb0cb76f5f",
        "storage_key": "property/6767906449166423/019d02c7-a96f-77c1-ac50-43eb0cb76f5f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14CYtUgHK4cRKHZO4WqJlsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_872c4a1a-b48a-4762-be30-a2299923eed9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Banner Health Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "4530 E Ray Rd Ste 190, Phoenix, AZ 85044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-917c-77dd-8463-e2c950b9f5b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-917c-77dd-8463-e2c950b9f5b7",
        "storage_key": "property/6767906449166423/019d02c7-917c-77dd-8463-e2c950b9f5b7.webp",
        "width": 500,
        "height": 281
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-health-clinic-ray-family-medicine?utm_source=gmb&utm_medium=listing&utm_campaign=bhc_webcta&y_source=1_MTE5MDc0MDktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9548951539260314223&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-health-clinic",
      "poi_latitude": "33.32115100000001",
      "poi_longitude": "-111.9864316",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-827-5420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a96f-77c1-ac50-43eb0cb76f5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a96f-77c1-ac50-43eb0cb76f5f",
        "storage_key": "property/6767906449166423/019d02c7-a96f-77c1-ac50-43eb0cb76f5f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJuabYYEUEK4cRb9IHG9WwhIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c0ced423-5661-4393-9171-57a12b8ccc15",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "South Mountain Park and Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10919 S Central Ave, Phoenix, AZ 85042, USA",
      "poi_short_description": "Vast park with desert scenery and mountain trails for hiking, biking, and horseback riding amid wildlife.",
      "poi_long_description": "People say this park offers hiking trails with stunning views of the valley, and is a great place for picnics and outdoor gatherings. They highlight the spaciousness, allowing visitors to avoid crowds, and the mix of easy and difficult trails suitable for various fitness levels. They also like the well-maintained trails, convenient parking, and restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-91dc-74a8-ab72-48152d280d6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-91dc-74a8-ab72-48152d280d6e",
        "storage_key": "property/6767906449166423/019d02c7-91dc-74a8-ab72-48152d280d6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/administration/departments/parks/activities-facilities/trails/south-mountain-parkpreserve.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7241350686142470773&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-mountain-park-and-preserve",
      "poi_latitude": "33.3403368",
      "poi_longitude": "-112.0609473",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a975-76ad-94e5-b63da51bc31f",
        "storage_key": "property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfybkSL8aK4cRdZqNLRVyfmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de8f864e-d55a-44e3-bde8-2119e80e47a4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Pima Canyon Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4500 E Pima Canyon Rd, Phoenix, AZ 85044, USA",
      "poi_short_description": "Desert, 5-8 mile-long park for hiking and picnicking, featuring a variety of well-maintained trails, plus views.",
      "poi_long_description": "People say this hiking area offers a variety of trails suitable for all levels, from easy walks to challenging climbs, and is great for hiking, mountain biking, and trail running. They highlight the beautiful scenery, well-maintained trails, and convenient access to restrooms and parking. They also like the numerous trail options, allowing for exploration and discovery of petroglyphs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9302-7476-904e-221adc469012.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9302-7476-904e-221adc469012",
        "storage_key": "property/6767906449166423/019d02c7-9302-7476-904e-221adc469012.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/south-mountain/trail-descriptions-and-map",
      "poi_directions_map_url": "https://maps.google.com/?cid=10626571712102621581&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pima-canyon-trailhead",
      "poi_latitude": "33.3628897",
      "poi_longitude": "-111.9859189",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-262-7393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a975-76ad-94e5-b63da51bc31f",
        "storage_key": "property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8e3Ou0FK4cRjWEXkKsqeZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_2557c37e-79cd-4a53-a068-778edb4b5063",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Desert Breeze Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "660 North Desert Breeze Blvd E, Chandler, AZ 85226, USA",
      "poi_short_description": "Family-friendly outdoor destination featuring play areas and sports facilities alongside a train and fishing lake.",
      "poi_long_description": "People say this park offers a lake for fishing, a train ride, a splash pad, a playground, tennis courts, and picnic areas. They highlight the relaxing and peaceful vibe, and the beautiful scenery with trees, ducks, and a hummingbird garden. They also like the clean facilities and well-maintained vegetation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-95b9-747f-913e-d96ee6cf2608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-95b9-747f-913e-d96ee6cf2608",
        "storage_key": "property/6767906449166423/019d02c7-95b9-747f-913e-d96ee6cf2608.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://desertbreezerr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6836529641264262526&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-breeze-park",
      "poi_latitude": "33.3119719",
      "poi_longitude": "-111.919828",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-893-6652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a975-76ad-94e5-b63da51bc31f",
        "storage_key": "property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6eviMUGK4cRfi38u3w74F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cf9882b8-ff25-4bf9-909e-69605a618c4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Raven Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3636 E Baseline Rd, Phoenix, AZ 85042, USA",
      "poi_short_description": "Championship course with lush fairways, fast greens and strategically positioned bunkers.",
      "poi_long_description": "People say this public golf course offers a beautiful and challenging layout with well-maintained fairways, greens, and tee boxes. They highlight the relaxing atmosphere, scenic views, and the inclusion of a driving range with chipping and putting areas. They also like the friendly and helpful staff, and the smooth, enjoyable experience from start to finish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9605-70c1-ac33-b1c80eaa0481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9605-70c1-ac33-b1c80eaa0481",
        "storage_key": "property/6767906449166423/019d02c7-9605-70c1-ac33-b1c80eaa0481.webp",
        "width": 1000,
        "height": 730
      },
      "poi_business_url": "https://www.ravenphx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9667067333721648175&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raven-golf-club",
      "poi_latitude": "33.3808164",
      "poi_longitude": "-112.0057638",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-243-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-aca8-73a5-b357-db4d9b8cef83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-aca8-73a5-b357-db4d9b8cef83",
        "storage_key": "property/6767906449166423/019d02c7-aca8-73a5-b357-db4d9b8cef83.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2CQlIMPK4cRL-xCjoVSKIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_a5701a19-a076-4067-8c70-93c0aae0195d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Whirlwind Golf Club at Wild Horse Pass",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5692 W North Loop Rd, Chandler, AZ 85226, USA",
      "poi_short_description": "Desert-style option featuring 36 holes, a practice facility and a pro shop, plus a restaurant.",
      "poi_long_description": "People say this golf course offers two scenic and challenging layouts, Devil's Claw and Cattail, with smooth greens and generous fairways. They highlight the course conditions are top-notch, even during the summer heat, and the experience is resort-quality yet playable for all skill levels. They also like the friendly and helpful staff, and the well-maintained locker room facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9759-7777-abf3-9669b4f8f923.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9759-7777-abf3-9669b4f8f923",
        "storage_key": "property/6767906449166423/019d02c7-9759-7777-abf3-9669b4f8f923.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.whirlwindgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14687844691734083799&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whirlwind-golf-club-at-wild-horse-pass",
      "poi_latitude": "33.2697222",
      "poi_longitude": "-111.9902778",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-940-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-aca8-73a5-b357-db4d9b8cef83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-aca8-73a5-b357-db4d9b8cef83",
        "storage_key": "property/6767906449166423/019d02c7-aca8-73a5-b357-db4d9b8cef83.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4dS_JQDK4cR17jqdu201cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d5cc64c9-587d-4fec-8c9d-3cccdaa280e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Stellar Airpark-P19",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Geronimo St, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9857-73be-a60f-ae7d35981fb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9857-73be-a60f-ae7d35981fb8",
        "storage_key": "property/6767906449166423/019d02c7-9857-73be-a60f-ae7d35981fb8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.stellarairpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=960649327469354276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stellar-airpark-p19",
      "poi_latitude": "33.2988204",
      "poi_longitude": "-111.9178543",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-295-2683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-ad0b-7314-a5c9-a33c5785fc8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-ad0b-7314-a5c9-a33c5785fc8a",
        "storage_key": "property/6767906449166423/019d02c7-ad0b-7314-a5c9-a33c5785fc8a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8WdCcTIBK4cRJF2HPXnpVA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1e67e2d1-e21b-4e4d-bc3e-e2598bb6ca1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Stellar Air Hangars & Tiedowns",
      "poi_type": "Transportation & Transit",
      "poi_address": "209 S Stellar Pkwy, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9a78-75b7-966e-e0f9a32b5a71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9a78-75b7-966e-e0f9a32b5a71",
        "storage_key": "property/6767906449166423/019d02c7-9a78-75b7-966e-e0f9a32b5a71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=828023617348071712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stellar-air-hangars--tiedowns",
      "poi_latitude": "33.298681",
      "poi_longitude": "-111.917583",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-961-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-ad0b-7314-a5c9-a33c5785fc8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-ad0b-7314-a5c9-a33c5785fc8a",
        "storage_key": "property/6767906449166423/019d02c7-ad0b-7314-a5c9-a33c5785fc8a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ64M1bzIBK4cRIHGqyRe7fQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_aaaf5a72-bc5a-4f52-a822-cc2d53629890",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Intel - Chandler Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 W Chandler Blvd, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9ac3-72c1-963f-02dee167e5a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9ac3-72c1-963f-02dee167e5a7",
        "storage_key": "property/6767906449166423/019d02c7-9ac3-72c1-963f-02dee167e5a7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=501564151973696889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel---chandler-campus",
      "poi_latitude": "33.3091336",
      "poi_longitude": "-111.9327346",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-820-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGb5SZRqqK4cReVV2VvDp9QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_63d739c8-af8c-46cb-94fc-339103e1bce0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Intel CH7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Intel CH7, CH7 N Pvt, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9d15-74ef-87e0-b027a18d5eca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9d15-74ef-87e0-b027a18d5eca",
        "storage_key": "property/6767906449166423/019d02c7-9d15-74ef-87e0-b027a18d5eca.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10838182310650502717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-ch7",
      "poi_latitude": "33.3109104",
      "poi_longitude": "-111.9324318",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3dZlxLkGK4cRPd4-bWP1aJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6d4f2d8b-5d8e-40db-961f-559c16322c44",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Microchip Technology Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2355 W Chandler Blvd, Chandler, AZ 85224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9e4e-77f6-80bb-e03e01095283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9e4e-77f6-80bb-e03e01095283",
        "storage_key": "property/6767906449166423/019d02c7-9e4e-77f6-80bb-e03e01095283.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.microchip.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075981335751919628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "microchip-technology-inc",
      "poi_latitude": "33.3041648",
      "poi_longitude": "-111.8836135",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-792-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQzLeMoAK4cRDIhNxdlbGd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_38d7eb8e-d2ef-4424-9b27-95acf391c3dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Amazon AZA10",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8600 S Science Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-9fc0-76bd-84c6-fbc65f75bf19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9fc0-76bd-84c6-fbc65f75bf19",
        "storage_key": "property/6767906449166423/019d02c7-9fc0-76bd-84c6-fbc65f75bf19.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17057723990554394837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-aza10",
      "poi_latitude": "33.3383978",
      "poi_longitude": "-111.8970169",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZTAyQQHK4cR1UCn_Zc1uew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f597615d-4aaf-4980-8f0d-7ab1a5b47a8d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Intel CH5",
      "poi_type": "Major Employers & Offices",
      "poi_address": "CH5 N Pvt, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a1b7-750c-991a-718e0aa4abc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a1b7-750c-991a-718e0aa4abc5",
        "storage_key": "property/6767906449166423/019d02c7-a1b7-750c-991a-718e0aa4abc5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17888343945654009883&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-ch5",
      "poi_latitude": "33.3101379",
      "poi_longitude": "-111.9352791",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-554-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-_bCboGK4cRG4C3xAoqQPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_08ad55fe-127a-4950-9add-dccf29b66b42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Benihana - Chandler",
      "poi_type": "Restaurants",
      "poi_address": "3025 W Chandler Blvd, Chandler, AZ 85226, USA",
      "poi_short_description": "Hibachi chain serving Japanese dishes grilled tableside by theatrical chefs.",
      "poi_long_description": "Diners say this Japanese restaurant serves up delicious fried rice, steak, and matcha ice cream, and they praise the entertaining teppanyaki chefs, especially Izzy and Savannah. They also highlight the attentive and friendly service, and the fun, engaging atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb387-0646-720c-923f-a0b9dbcbd403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb387-0646-720c-923f-a0b9dbcbd403",
        "storage_key": "property/6767906449166423/019eb387-0646-720c-923f-a0b9dbcbd403.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.benihana.com/locations/chandler/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10587472721842232333&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "benihana---chandler",
      "poi_latitude": "33.3039975",
      "poi_longitude": "-111.8954351",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-812-4701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4_T1tIAK4cRDVyLflhC7pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_1a36a089-5baf-43b5-93d5-e28ae8a80c43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Hashtag 48 Modern Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "5965 W Ray Rd Ste 20, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this restaurant's fresh, flavorful Mediterranean food, including dishes like Bati kebab and Hawawshi, with generous portions and beautiful presentation. They also highlight the clean, modern, and welcoming atmosphere, along with the excellent hookah. Guests mention the staff are friendly, attentive, and provide great service, making for an enjoyable dining experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb387-09c2-7198-aa4d-664ff2391eda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb387-09c2-7198-aa4d-664ff2391eda",
        "storage_key": "property/6767906449166423/019eb387-09c2-7198-aa4d-664ff2391eda.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hashtag48modernkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6465881897948278210&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hashtag-48-modern-kitchen",
      "poi_latitude": "33.3187923",
      "poi_longitude": "-111.9448556",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-397-2043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5XhWc0HK4cRwu3VFlRtu1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_54372882-1006-4225-8acd-64cf991e6d46",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "7151 W Ray Rd, Chandler, AZ 85226, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "People say this restaurant serves delicious pizookies, prime rib, jambalaya, and wings. They also highlight the great lunch deals, happy hour specials, and wide selection of beers.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb387-09b5-742c-b12d-177b8428f086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb387-09b5-742c-b12d-177b8428f086",
        "storage_key": "property/6767906449166423/019eb387-09b5-742c-b12d-177b8428f086.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/az/chandler-ray-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=10556025863537849571&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "33.3194131",
      "poi_longitude": "-111.9658961",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-320-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3sfUt4FK4cR43QCPJiJfpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_472095b0-f99a-45e4-a8ae-5b898b617ac5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "980 N 54th St, Chandler, AZ 85226, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Diners like this steakhouse's perfectly cooked steaks, including ribeye and sirloin, along with delicious sides like loaded baked potatoes and stuffed mushrooms. They also highlight the reasonable prices and the warm, welcoming atmosphere. Guests consistently praise the attentive and friendly staff, noting their excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb387-0601-74eb-b42e-29c86a924b38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb387-0601-74eb-b42e-29c86a924b38",
        "storage_key": "property/6767906449166423/019eb387-0601-74eb-b42e-29c86a924b38.webp",
        "width": 1210,
        "height": 911
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/az/chandler/chandler/5455?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:chandler-az-5455_pl:locurl_rd:1394",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324700759293470539&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.319428",
      "poi_longitude": "-111.969011",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-403-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cfX9TsEK4cRS6esoAoiCqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_5ccc677e-1232-42b5-bda3-ee37e9f1aac0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Sweet Magnolia Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "4929 E Chandler Blvd Ste 405, Phoenix, AZ 85048, USA",
      "poi_short_description": "Food truck and brick-and-mortar joint offering a range of BBQ faves including ribs, pulled pork and brisket with various sides.",
      "poi_long_description": "Diners say this barbecue restaurant offers delicious, tender, and flavorful smoked meats like brisket and pulled pork, along with outstanding sides such as mac and cheese, collard greens, and sweet potatoes. They also highlight the friendly, welcoming, and attentive staff, noting the fast service and reasonable prices. Guests mention the clean, family-friendly atmosphere and the overall excellent dining experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb387-05fb-7465-850f-e26816e36e58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb387-05fb-7465-850f-e26816e36e58",
        "storage_key": "property/6767906449166423/019eb387-05fb-7465-850f-e26816e36e58.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://sweetmagnoliasmokehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10891493600723640578&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sweet-magnolia-smokehouse",
      "poi_latitude": "33.3042269",
      "poi_longitude": "-111.9777373",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-232-3661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2m7flIFK4cRAqGSaLlbJpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_00954008-e785-4dc6-9d07-ca1e07203d4d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Over Easy",
      "poi_type": "Restaurants",
      "poi_address": "7131 W Ray Rd Ste #7, Chandler, AZ 85226, USA",
      "poi_short_description": "Casual eatery serving breakfast classics and pancakes alongside lunch fare and cocktails.",
      "poi_long_description": "People say this breakfast restaurant serves delicious chicken and waffles, biscuits and gravy, and omelettes. They highlight the good prices, generous portions, and fresh-squeezed orange juice. They also like the friendly and attentive staff, and the pleasant patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb387-05b5-7050-8fb7-41534dbd8541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb387-05b5-7050-8fb7-41534dbd8541",
        "storage_key": "property/6767906449166423/019eb387-05b5-7050-8fb7-41534dbd8541.webp",
        "width": 1280,
        "height": 1271
      },
      "poi_business_url": "https://eatatovereasy.com/locations/chandler-ray-rd/?utm_source=Google+Business+Profile&utm_medium=Website+Link&utm_campaign=Local+SEO",
      "poi_directions_map_url": "https://maps.google.com/?cid=14631946542167813016&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "over-easy",
      "poi_latitude": "33.3180506",
      "poi_longitude": "-111.9673255",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-306-6681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbpOkGUFK4cRmOtqUtsdD8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_17988b13-625f-4659-b64a-a986c7b69bab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4734 E Ray Rd, Phoenix, AZ 85044, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this store is clean, well-organized, and consistently stocked with a wide variety of products. They also highlight the friendly, helpful staff and reasonable prices.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38a-1396-7649-a1c0-2896af24dc00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-1396-7649-a1c0-2896af24dc00",
        "storage_key": "property/6767906449166423/019eb38a-1396-7649-a1c0-2896af24dc00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ahwatukee/909",
      "poi_directions_map_url": "https://maps.google.com/?cid=1642337427282385037&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.3218984",
      "poi_longitude": "-111.9811417",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-893-9333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5ac-70de-a1e6-fac6f329e8ef",
        "storage_key": "property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN-CkeEYEK4cRjdh-SjDByhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9da9ab41-e3d2-49c6-b03c-a21e245dd57a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3721 E Thomas Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Wide-ranging retailer, offering groceries and household goods alongside services like photo printing and repairs, plus friendly staff, helpful employees and self-checkout options.",
      "poi_long_description": "Customers consistently describe this store as well-stocked with a wide variety of products, clean and organized, and note the friendly staff who provide excellent service.\n\nOther reviews mention many items can be locked up, making it difficult to get assistance, and staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38a-1320-704b-b12f-030b18c973a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-1320-704b-b12f-030b18c973a2",
        "storage_key": "property/6767906449166423/019eb38a-1320-704b-b12f-030b18c973a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/2515-phoenix-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5974062166260505646&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.4789848",
      "poi_longitude": "-112.0009274",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-685-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5ac-70de-a1e6-fac6f329e8ef",
        "storage_key": "property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ88sfF7UNK4cRLtwOZuMh6FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_95b3544a-44ab-4d10-970b-abe543cd443a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "World Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "860 N 54th St, Chandler, AZ 85226, USA",
      "poi_short_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_long_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38a-159a-732f-ac6a-7043bbbb5124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-159a-732f-ac6a-7043bbbb5124",
        "storage_key": "property/6767906449166423/019eb38a-159a-732f-ac6a-7043bbbb5124.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.worldmarket.com/stores/store?id=CP29",
      "poi_directions_map_url": "https://maps.google.com/?cid=11897023087722645240&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "world-market",
      "poi_latitude": "33.3165073",
      "poi_longitude": "-111.9707787",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-758-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5ac-70de-a1e6-fac6f329e8ef",
        "storage_key": "property/6767906449166423/019d02c7-a5ac-70de-a1e6-fac6f329e8ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo0kUAD0EK4cR-EZUFHe3GqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_bf138ef1-1d40-49ca-bd78-f3bd1636f492",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4025 E Chandler Blvd Ste 38, Phoenix, AZ 85048, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and high-quality food items, including fresh produce, frozen meals, and an excellent selection of wines and flowers. They also highlight the reasonable prices and the consistently clean and well-stocked store. Visitors frequently mention the staff are friendly, helpful, and create a welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38a-12e9-706a-8855-726ed657b4e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-12e9-706a-8855-726ed657b4e4",
        "storage_key": "property/6767906449166423/019eb38a-12e9-706a-8855-726ed657b4e4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/az/phoenix/177/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5187478158214162211&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.3039882",
      "poi_longitude": "-111.9944475",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-759-2293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5b2-77cb-a534-0c2d903ac32d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5b2-77cb-a534-0c2d903ac32d",
        "storage_key": "property/6767906449166423/019d02c7-a5b2-77cb-a534-0c2d903ac32d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp8xJUGEEK4cRI-dzhOaf_Uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e23221f8-1691-4bb4-b5eb-cea85085b11e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "K1 Speed Phoenix",
      "poi_type": "Entertainment",
      "poi_address": "2501 E Magnolia St, Phoenix, AZ 85034, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "Visitors say this go-kart racing venue offers fast, well-maintained karts and a fun, challenging track with tight turns and long straights. They also highlight the friendly, helpful, and accommodating staff, who prioritize safety and provide clear instructions.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38b-f4ef-7754-8205-5ea8b5024bb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38b-f4ef-7754-8205-5ea8b5024bb2",
        "storage_key": "property/6767906449166423/019eb38b-f4ef-7754-8205-5ea8b5024bb2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://k1speed.com/phoenix-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16366161456476043528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "k1-speed-phoenix",
      "poi_latitude": "33.4218087",
      "poi_longitude": "-112.0284479",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-275-5278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVamTvTwOK4cRCLnxDSJJIOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_e93ed95c-fd7b-47be-9572-d48c06cf69da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Main Event Tempe",
      "poi_type": "Entertainment",
      "poi_address": "8545 S Emerald Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "Chain featuring arcade games, Bowling and Laser Tag, as well as a rope-walking attraction.",
      "poi_long_description": "Guests consistently praise this entertainment center for its wide variety of activities, including bowling and laser tag, and its suitability for family outings. Many reviewers also highlight the delicious food and drinks, the friendly and attentive staff, and the clean, fun atmosphere.\n\nSome reviews mention the service can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38b-f4e6-72e0-866f-4af36a975348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38b-f4e6-72e0-866f-4af36a975348",
        "storage_key": "property/6767906449166423/019eb38b-f4e6-72e0-866f-4af36a975348.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/arizona/tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=3811411622178510185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-event-tempe",
      "poi_latitude": "33.337249",
      "poi_longitude": "-111.9674006",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-753-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5a1-708f-bca6-84d707133cd2",
        "storage_key": "property/6767906449166423/019d02c7-a5a1-708f-bca6-84d707133cd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJscW22MwFK4cRadW-OK3a5DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9b8d0645-bdc6-488f-b811-974d8f1a53fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Game Show Battle Rooms - Phoenix (Chandler)",
      "poi_type": "Entertainment",
      "poi_address": "6909 W Ray Rd Ste 29, Chandler, AZ 85226, USA",
      "poi_short_description": "Entertainment venue where teams compete in live game shows hosted by charismatic hosts.",
      "poi_long_description": "People say this amusement center offers a fun, high-energy game show experience with engaging hosts and a variety of games based on popular shows like Family Feud and Wheel of Fortune. They also highlight the team-building aspect, making it a great choice for families, friends, and work events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38b-f61d-703e-b71f-0de859a0f707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38b-f61d-703e-b71f-0de859a0f707",
        "storage_key": "property/6767906449166423/019eb38b-f61d-703e-b71f-0de859a0f707.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.gameshowbattlerooms.com/phoenix",
      "poi_directions_map_url": "https://maps.google.com/?cid=5196592165083696833&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "game-show-battle-rooms---phoenix-chandler",
      "poi_latitude": "33.3192367",
      "poi_longitude": "-111.9606557",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-624-8099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw1ieKScFK4cRwU5kmgoBHkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_4295610e-f62d-432c-85bf-dc36171b9617",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Harkins Theatres Chandler Fashion",
      "poi_type": "Entertainment",
      "poi_address": "3159 W Chandler Blvd, Chandler, AZ 85226, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "People say this movie theater offers a wide variety of snacks and drinks, and the reclining seats are comfortable. They highlight the clean theaters, spacious seating, and friendly staff. They also like the convenient location and the option to pre-order food online.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38b-fa39-730a-aee8-e79f38f2a88c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38b-fa39-730a-aee8-e79f38f2a88c",
        "storage_key": "property/6767906449166423/019eb38b-fa39-730a-aee8-e79f38f2a88c.webp",
        "width": 1280,
        "height": 953
      },
      "poi_business_url": "https://harkins.com/theatres/chandler-fashion/?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4664888882085787831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-chandler-fashion",
      "poi_latitude": "33.29883",
      "poi_longitude": "-111.8992654",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-732-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38c-020b-74ef-ace9-1a6c8c419d1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb38c-020b-74ef-ace9-1a6c8c419d1a",
        "storage_key": "property/6767906449166423/019eb38c-020b-74ef-ace9-1a6c8c419d1a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbn9MisHK4cRt3hk_bgDvUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_be61d96f-8d66-42ad-af13-7b0421407d73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Bowling",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b25e626a-3aab-4442-b6db-b27fcad7dfeb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Rawhide Event Center",
      "poi_type": "Entertainment",
      "poi_address": "5244 S 48th St, Chandler, AZ 85226, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this event venue is a great place for various activities and events, offering a large, flexible space. They also highlight the helpful staff, ample parking, and fun, immersive experiences.\n\nSome reviews mention the venue can be overly warm.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019eb38b-f553-73be-861d-02857952d4f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38b-f553-73be-861d-02857952d4f6",
        "storage_key": "property/6767906449166423/019eb38b-f553-73be-861d-02857952d4f6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.rawhide.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16384304629192698789&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rawhide-event-center",
      "poi_latitude": "33.2701932",
      "poi_longitude": "-111.9809506",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-502-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6c7SsL8DK4cRpavRokC-YOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_74116871-a929-4ad3-aa74-c576e45bce04",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Kyrene del Milenio Elementary School",
      "poi_type": "Education",
      "poi_address": "4630 E Frye Rd, Phoenix, AZ 85048, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-05c2-75be-a748-3d0b3df776e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b2-05c2-75be-a748-3d0b3df776e7",
        "storage_key": "property/6767906449166423/019f01b2-05c2-75be-a748-3d0b3df776e7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mil.kyrene.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8019275747293207186&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kyrene-del-milenio-elementary-school",
      "poi_latitude": "33.298655",
      "poi_longitude": "-111.9835997",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-541-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5af-744a-89d8-65e7f50a6e10",
        "storage_key": "property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3aKswXEEK4cRkhpR4c0wSm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_57513b8c-395a-4132-bdc5-1a928ca0c5e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Kyrene Akimel A-al Middle School",
      "poi_type": "Education",
      "poi_address": "2720 E Liberty Ln, Phoenix, AZ 85048, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-0325-7209-b927-519f33e8564e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b2-0325-7209-b927-519f33e8564e",
        "storage_key": "property/6767906449166423/019f01b2-0325-7209-b927-519f33e8564e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://aki.kyrene.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3470844985166976941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kyrene-akimel-a-al-middle-school",
      "poi_latitude": "33.2931265",
      "poi_longitude": "-112.024734",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-541-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5af-744a-89d8-65e7f50a6e10",
        "storage_key": "property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJETmisKIEK4cRrddS6x_rKjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4924fc49-bbab-4cbe-b068-f58e7cd02983",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Desert Vista High School",
      "poi_type": "Education",
      "poi_address": "16440 S 32nd St, Phoenix, AZ 85048, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b1-fdfa-71dc-abac-f0ba856c8f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b1-fdfa-71dc-abac-f0ba856c8f5c",
        "storage_key": "property/6767906449166423/019f01b1-fdfa-71dc-abac-f0ba856c8f5c.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.tempeunion.org/desertvista",
      "poi_directions_map_url": "https://maps.google.com/?cid=9219560487597163541&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desert-vista-high-school",
      "poi_latitude": "33.2957714",
      "poi_longitude": "-112.0151679",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-706-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5af-744a-89d8-65e7f50a6e10",
        "storage_key": "property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvdjkfJAEK4cRFcR0iGp18n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_df8b33b4-30b6-4f54-ab80-50c454fb1a53",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Ironwood Library",
      "poi_type": "Education",
      "poi_address": "4333 E Chandler Blvd, Phoenix, AZ 85048, USA",
      "poi_short_description": "Comfortable public library providing programs and activities for children and adults, plus Wi-Fi.",
      "poi_long_description": "People say this public library offers a wide selection of books, DVDs, and CDs, as well as computers, a seed bank, and a play area for children. They highlight the clean and organized facilities, the quiet and comfortable atmosphere, and the helpful and friendly staff. They also like the convenient holds lockers and the regular events and programming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-01d0-7655-a62a-63cfe11dacf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b2-01d0-7655-a62a-63cfe11dacf9",
        "storage_key": "property/6767906449166423/019f01b2-01d0-7655-a62a-63cfe11dacf9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.phoenixpubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10855409037686414980&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ironwood-library",
      "poi_latitude": "33.3048534",
      "poi_longitude": "-111.9895115",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-262-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a5af-744a-89d8-65e7f50a6e10",
        "storage_key": "property/6767906449166423/019d02c7-a5af-744a-89d8-65e7f50a6e10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcb7ZdGYEK4cRhB7dXgEpppY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_dd25ee40-fa5b-470a-8437-5f8c60e6ba7b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Desert Foothills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1010 E Marketplace Wy SE, Phoenix, AZ 85048, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this park offers well-maintained baseball, softball, soccer, volleyball, and pickleball fields, along with a large playground featuring three separate areas. They also highlight the beautiful views, ample open space for walking, and pet-friendly environment. Visitors appreciate the good lighting after dark and the availability of picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b1-fe5f-770a-bf0c-ea0f761bf04d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b1-fe5f-770a-bf0c-ea0f761bf04d",
        "storage_key": "property/6767906449166423/019f01b1-fe5f-770a-bf0c-ea0f761bf04d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/d-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=457427683790517464&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desert-foothills-park",
      "poi_latitude": "33.3054747",
      "poi_longitude": "-112.0599192",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-262-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a975-76ad-94e5-b63da51bc31f",
        "storage_key": "property/6767906449166423/019d02c7-a975-76ad-94e5-b63da51bc31f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWg6fDAbK4cR2HTDCg4cWQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bacdbd40-414b-4a57-a513-c15efaa03d33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Pecos Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "16864 S 40th St, Phoenix, AZ 85048, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-05b4-7489-9975-d93f6e727d0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b2-05b4-7489-9975-d93f6e727d0b",
        "storage_key": "property/6767906449166423/019f01b2-05b4-7489-9975-d93f6e727d0b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://routes.valleymetro.org/timetables/transit_route/934?type=5",
      "poi_directions_map_url": "https://maps.google.com/?cid=12034780692418204800&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pecos-park--ride",
      "poi_latitude": "33.2937496",
      "poi_longitude": "-111.997246",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-0bfb-7170-b846-7d56f231b803.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f01b2-0bfb-7170-b846-7d56f231b803",
        "storage_key": "property/6767906449166423/019f01b2-0bfb-7170-b846-7d56f231b803.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7KeYH4EK4cRgBRR2UYhBKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_93a9b42f-3651-4077-8d6a-9da680285a0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Phoenix Sky Harbor International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3400 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_long_description": "People say this airport offers a convenient sky train connecting terminals and the rental car center, and has a modern design with moving walkways. They also highlight the friendly staff, clean bathrooms, and easy navigation.\n\nOther reviews mention the airport can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b1-fe49-749d-9322-5b17520ee17d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b1-fe49-749d-9322-5b17520ee17d",
        "storage_key": "property/6767906449166423/019f01b1-fe49-749d-9322-5b17520ee17d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436507786966396482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-sky-harbor-international-airport",
      "poi_latitude": "33.435249",
      "poi_longitude": "-112.010124",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-ad0b-7314-a5c9-a33c5785fc8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-ad0b-7314-a5c9-a33c5785fc8a",
        "storage_key": "property/6767906449166423/019d02c7-ad0b-7314-a5c9-a33c5785fc8a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXADM1wOK4cRQu5W4tU19YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_398b379b-6d2d-4375-9e53-4d1599252414",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Tempe Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 E 5th St, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b1-fe72-7701-a014-292dcdfb333a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b1-fe72-7701-a014-292dcdfb333a",
        "storage_key": "property/6767906449166423/019f01b1-fe72-7701-a014-292dcdfb333a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/government/engineering-and-transportation/transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9749899852196634873&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tempe-transportation-center",
      "poi_latitude": "33.4259451",
      "poi_longitude": "-111.9367275",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-0bf5-736b-b555-ecba8645a543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f01b2-0bf5-736b-b555-ecba8645a543",
        "storage_key": "property/6767906449166423/019f01b2-0bf5-736b-b555-ecba8645a543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC6cP19gIK4cR-WDQJUKaToc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a64965ca-ff68-400f-8134-04837f1b6da6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "50th St/Washington St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-01de-7628-a1bb-9799d8ee5021.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b2-01de-7628-a1bb-9799d8ee5021",
        "storage_key": "property/6767906449166423/019f01b2-01de-7628-a1bb-9799d8ee5021.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5967065678332704357&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "50th-stwashington-st",
      "poi_latitude": "33.446983",
      "poi_longitude": "-111.975266",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbTH570OK4cRZTZynJ5Gz1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e07403c2-0b25-488c-a725-5f7fb7fb92df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "poi_name": "Wells Fargo & Co. Chandler Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2850 S Price Rd, Chandler, AZ 85286, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f01b2-01d8-7308-aa01-e1cc21ee04a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01b2-01d8-7308-aa01-e1cc21ee04a4",
        "storage_key": "property/6767906449166423/019f01b2-01d8-7308-aa01-e1cc21ee04a4.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.wellsfargo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13512245822728823405&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wells-fargo--co-chandler-campus",
      "poi_latitude": "33.2655934",
      "poi_longitude": "-111.8914146",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-a934-76b1-a83a-6350adf0bc11",
        "storage_key": "property/6767906449166423/019d02c7-a934-76b1-a83a-6350adf0bc11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafdTm1gAK4cRbeKBHfwjhbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d06e8849979022738336060c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0c1da2eb9bb219583283b63a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cbbe538df49d173bcdf46aae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0a7daec342509f03e939ec4b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e461c66c6763f34e819e5ee5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2b8d10b128d722da02709f16",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_66fa9712-edd1-467a-8383-61986898d160",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "rating": "5.0",
      "name": "Brittney Boyce",
      "text": "Multi Appreciation Review:\n\nTaylor, the  community manager, is amazing! We recently moved in and she carefully assisted with making sure all our concerns and or call outs were addressed. She is very thoughtful, professional, and most of all personable. I've observed her interactions with several tenants here and I can tell she really cares about the community and builds relationship with people here.\n\nCherie, the assistant manager, has a personality that's out of this world. I can tell she really cares about the upkeep of the community and that everyone maintains a high level of respect for not only our homes, but others around us. She's very professional, personable, and made sure we were taken care of.\n\nEvelyn, the leasing agent, is so sweet. She's normally the first smiling face I see when we go to the office. She's knowledgeable and is always on top of things. She was able to answer any question we had, and if she didn't have the answer, she followed up in a timely manner. I appreciate her awesome customer service.",
      "date": "2025-07-26",
      "title": ""
    },
    {
      "id": "custom_1532fdd4-5741-4468-81e1-0cb359ff7663",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "rating": "5.0",
      "name": "Julie Lopez",
      "text": "I had a great experience touring this apartment! The leasing agent Evelyn was incredibly friendly, professional, and knowledgeable — they answered all of my questions thoroughly and made me feel welcome from the moment I arrived. The building was clean and secure, and the unit itself was even better in person — bright, spacious, and thoughtfully designed. I really appreciated the attention to detail and how well-maintained everything was. This place is definitely at the top of my list!",
      "date": "2025-07-19",
      "title": ""
    },
    {
      "id": "custom_ac835f1f-f9aa-4803-8b0f-1f56d14bd795",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "rating": "5.0",
      "name": "Miranda Mendoza",
      "text": "We had a rough experience with a previous apartment, but walking into Allegro completely changed the game—thanks to Evelyn in leasing! From the moment we arrived, she greeted us with such warmth and professionalism. She was incredibly knowledgeable, patient, and genuinely helpful throughout the entire process. Evelyn made us feel confident and cared for, and we left feeling excited about our next chapter. Highly recommend working with her if you’re considering Allegro!",
      "date": "2025-08-01",
      "title": ""
    },
    {
      "id": "custom_de363a76-86ec-41f6-85e4-adbab05fa5b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "rating": "5.0",
      "name": "Bayleigh Seymour",
      "text": "I love Allegro! The front desk staff is amazing and friendly! My move-in experience was so easy and quick! The maintenance guys are quick and thorough and Julissa is amazing!!!",
      "date": "2025-10-02",
      "title": ""
    },
    {
      "id": "custom_36e06149-3f57-4c7c-ba94-8eda86852f32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "rating": "5.0",
      "name": "Carmen Raines",
      "text": "If I could give you more than 5 stars I would give you 20! The staff is awesome and very caring, they help me out so much.\nEvelyn I give her a 30 for all her hard work",
      "date": "2025-07-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bb63edf5-9f77-4b07-a437-c5c0066177bc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c8-b7de-7538-8af4-777bce6b747f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and free weights.",
        "public_id": "019d02c8-b7de-7538-8af4-777bce6b747f",
        "storage_key": "property/6767906449166423/019d02c8-b7de-7538-8af4-777bce6b747f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9dALuhGgST6"
    },
    {
      "id": "custom_e9332eeb-f35d-49db-a107-91ee946cc271",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c8-1008-72c0-ad2b-3661fe827b68.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern lobby seating area with cane-backed chairs and a marble coffee table.",
        "public_id": "019d02c8-1008-72c0-ad2b-3661fe827b68",
        "storage_key": "property/6767906449166423/019d02c8-1008-72c0-ad2b-3661fe827b68.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7cDLUtCFGqx"
    },
    {
      "id": "custom_442104c3-e145-4bc9-8b7c-06abd5185858",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c8-b7e7-76cf-bd52-d94b75bbfd6f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open-concept living room and kitchen area with a white sofa, blue accent chair, and kitchen island with bar stools.",
        "public_id": "019d02c8-b7e7-76cf-bd52-d94b75bbfd6f",
        "storage_key": "property/6767906449166423/019d02c8-b7e7-76cf-bd52-d94b75bbfd6f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1260 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sZvsMJ1hvo7"
    },
    {
      "id": "custom_045a9213-9df1-4dd7-94d2-762967b5991b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c8-1a08-7799-aacb-dd4f1833ba8e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with a ceiling fan and stainless steel appliances.",
        "public_id": "019d02c8-1a08-7799-aacb-dd4f1833ba8e",
        "storage_key": "property/6767906449166423/019d02c8-1a08-7799-aacb-dd4f1833ba8e.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 2 BA | 1334 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=C1BSgayYtKn"
    },
    {
      "id": "custom_1b684e85-d902-483d-a240-e2471329bf0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c8-b9da-7056-a6a9-8192d0086d02.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen and living area with wood-look flooring.",
        "public_id": "019d02c8-b9da-7056-a6a9-8192d0086d02",
        "storage_key": "property/6767906449166423/019d02c8-b9da-7056-a6a9-8192d0086d02.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 850 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FGXJsSinBXN"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199bff7-0064-7249-abc4-130a02c74efc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "allegro",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "allegro-apartments-in-unit-laundry-phoenix",
      "search_query": "apartments with in-unit laundry Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Phoenix",
      "h2_subtitle": "Discover Allegro apartments with in-unit laundry in Phoenix, AZ. Enjoy modern amenities in the vibrant Ahwatukee Foothills Village.",
      "page_copy": "Welcome to Allegro, where convenience meets comfort in Phoenix, AZ. Our apartments with in-unit laundry offer the perfect solution for those who value efficiency and ease in their daily lives. Enjoy spacious one, two, and three-bedroom homes with modern finishes and plenty of natural light. Located in the heart of Ahwatukee Foothills Village, our community provides easy access to all Phoenix has to offer.\n\nAt Allegro, luxurious amenities like sparkling pools, a well-equipped fitness center, and a welcoming clubhouse enrich your living experience. Each apartment, complete with in-unit laundry, caters to your lifestyle, simplifying your chores so you can focus on enjoying the serene surroundings and engaging community. Visit today and see why Allegro is the preferred choice for apartment living in Phoenix.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Phoenix, AZ",
      "seo_description": "Allegro offers spacious apartments with in-unit laundry in Phoenix, AZ. Enjoy modern amenities and a prime location in Ahwatukee Foothills Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-ahwatukee",
      "search_query": "resort-style pool apartments Ahwatukee Foothills Village",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in Ahwatukee",
      "h2_subtitle": "Explore Allegro's resort-style pool apartments in Ahwatukee Foothills Village. Dive into luxury living today.",
      "page_copy": "Welcome to Allegro, where resort-style living meets urban convenience in Ahwatukee Foothills Village. Our apartments are not just about a place to live, but a lifestyle to embrace. Dive into our sparkling resort-style pools, designed to offer you the ultimate relaxation and leisure experience right within your community.\n\nAt Allegro, living goes beyond just having a comfortable home. Our one, two, and three-bedroom apartments offer modern finishes, along with amenities such as a fitness center and a welcoming clubhouse. Unwind under the Arizona sun in our luxurious pool area or explore the vibrant surroundings of Ahwatukee. Discover why Allegro is the premier choice for those seeking resort-style pool apartments in this sought-after Phoenix neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in Ahwatukee",
      "seo_description": "Enjoy resort-style pool apartments at Allegro in Ahwatukee Foothills Village. Experience luxury and convenience in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-maricopa",
      "search_query": "air conditioned apartments near Maricopa County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Maricopa County",
      "h2_subtitle": "Find comfort in Allegro's air conditioned apartments near Maricopa County. Experience cool living with modern amenities.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Allegro, offering air conditioned apartments near Maricopa County. Our spacious one, two, and three-bedroom homes are designed to keep you cool during the hot Phoenix summers. Nestled in Ahwatukee Foothills Village, Allegro's location provides easy access to the best of Maricopa County, placing you close to shopping, dining, and entertainment.\n\nBeyond air conditioning, residents at Allegro enjoy a suite of resort-style amenities, including sparkling pools, a state-of-the-art fitness center, and a welcoming clubhouse. Experience a refreshing lifestyle in a community that values your comfort and convenience. Make Allegro your sanctuary in the desert and beat the heat with our top-notch amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Maricopa County",
      "seo_description": "Stay cool in Allegro's air conditioned apartments near Maricopa County. Enjoy modern living in Phoenix with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "dedicated-parking-apartments-phoenix-85048",
      "search_query": "dedicated parking apartments in Phoenix 85048",
      "category": "Amenity",
      "h1_title": "Dedicated Parking Apartments in Phoenix 85048",
      "h2_subtitle": "Discover Allegro's dedicated parking apartments in Phoenix 85048. Convenient and stress-free living awaits you.",
      "page_copy": "Welcome to Allegro, where convenience is at the forefront of our offerings. Located in the vibrant Phoenix 85048 area, our apartments come with the advantage of dedicated parking, ensuring you always have a hassle-free start and end to your day. Nestled in Ahwatukee Foothills Village, our community combines sleek, modern living with the essential convenience of secure parking spaces.\n\nOur one, two, and three-bedroom apartments feature modern designs and luxurious amenities such as a resort-style pool, fully-equipped fitness center, and welcoming clubhouse. But it's the comfort of knowing you have your own parking spot that truly sets Allegro apart. Enjoy life in an urban oasis, with all the amenities and dedicated parking that make living here both practical and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments in Phoenix 85048",
      "seo_description": "Allegro offers dedicated parking in Phoenix 85048. Enjoy convenient living with modern amenities and stress-free parking.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-phoenix",
      "search_query": "luxury apartments with fitness center in Phoenix",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center in Phoenix",
      "h2_subtitle": "Experience Allegro's luxury apartments with a fitness center in Phoenix. A vibrant lifestyle awaits you in a premier location.",
      "page_copy": "At Allegro, luxury meets wellness in the heart of Phoenix. Our upscale apartments offer access to a state-of-the-art fitness center, perfect for maintaining an active lifestyle without leaving the comfort of your community. Located in the scenic Ahwatukee Foothills Village, Allegro is where you can enjoy luxury living with all the modern conveniences you desire.\n\nChoose from one, two, or three-bedroom apartments, all featuring high-end finishes and abundant natural light. Beyond the fitness center, Allegro residents indulge in a selection of resort-style amenities, including sparkling pools and a vibrant clubhouse. Embrace a lifestyle of health, relaxation, and comfort at Allegro, where luxury and fitness go hand in hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center in Phoenix",
      "seo_description": "Live luxuriously at Allegro, offering a fitness center in Phoenix. Enjoy modern living with top amenities in an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-phoenix-az",
      "search_query": "one bedroom apartments phoenix az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Explore Allegro's one bedroom apartments in Phoenix, AZ. Comfort and modern living await in Ahwatukee Foothills Village.",
      "page_copy": "Discover the perfect one bedroom apartment at Allegro in Phoenix, AZ, where modern living meets convenience and style. Our thoughtfully designed apartments provide ample natural light and stylish finishes. Located in the desirable Ahwatukee Foothills Village, Allegro offers an ideal home base with easy access to local attractions and essentials.\n\nResidents enjoy resort-style amenities including lush swimming pools, a fully equipped fitness center, and a welcoming clubhouse perfect for socializing. Each one bedroom apartment comes complete with modern conveniences like a dishwasher and private balcony. Experience the vibrant lifestyle that awaits you at Allegro in Phoenix, AZ, where every detail is designed with your comfort in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Phoenix, AZ",
      "seo_description": "Discover comfort at Allegro with one bedroom apartments in Phoenix, AZ. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "two-bedroom-apts-ahwatukee-foothills",
      "search_query": "two bedroom apts in ahwatukee foothills",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apts in Ahwatukee Foothills",
      "h2_subtitle": "Find spacious two bedroom apts in Ahwatukee Foothills at Allegro. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Welcome to Allegro, where you’ll find spacious two bedroom apts nestled in the serene Ahwatukee Foothills. Our apartments offer the ideal blend of comfort and style, featuring modern finishes and abundant natural light in every room. Located in Phoenix, AZ, our community provides a peaceful retreat with easy access to the city’s best attractions and amenities.\n\nResidents of Allegro enjoy a wealth of resort-inspired features, including sparkling pools, a state-of-the-art fitness center, and a welcoming clubhouse. Each two bedroom apartment is equipped with convenient amenities such as dishwashers and private balconies, ensuring a comfortable lifestyle. Experience the best of Ahwatukee Foothills living at Allegro, where home is both luxurious and inviting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apts in Ahwatukee Foothills",
      "seo_description": "Discover two bedroom apts in Ahwatukee Foothills at Allegro. Modern amenities in a scenic community for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-maricopa-county",
      "search_query": "3 bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Discover Allegro's 3 bedroom apartments in Maricopa County, perfectly designed for spacious and modern living.",
      "page_copy": "Explore exceptional 3 bedroom apartments at Allegro, located in the heart of Maricopa County. These generously sized apartments offer a perfect balance of elegance and functionality, featuring an abundance of natural light and premium finishes. Situated in the picturesque Ahwatukee Foothills Village, our community blends the tranquility of nature with modern conveniences.\n\nAt Allegro, residents enjoy access to a variety of resort-worthy amenities. From sparkling pools and a modern fitness center to a vibrant clubhouse perfect for gatherings, every detail is designed to enhance your living experience. With modern conveniences like dishwashers and private balconies in each unit, Allegro's 3 bedroom apartments provide the perfect setting for family living or entertaining friends. Experience the best of Maricopa County living at Allegro.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Maricopa County",
      "seo_description": "Find spacious 3 bedroom apartments in Maricopa County at Allegro. Enjoy luxury living with modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "apartments-near-south-mountain-community-college",
      "search_query": "apartments near South Mountain Community College in Ahwatukee",
      "category": "School",
      "h1_title": "Apartments Near South Mountain Community College",
      "h2_subtitle": "Find ideal apartments near South Mountain Community College in Ahwatukee. Enjoy convenience and comfort at Allegro.",
      "page_copy": "Discover the perfect living space at Allegro, offering fantastic apartments near South Mountain Community College in the lovely Ahwatukee neighborhood. Our community provides a blend of convenience and relaxation, ideal for students and professionals alike. With a variety of spacious one, two, and three-bedroom floor plans, Allegro ensures you find the perfect fit for your lifestyle.\n\nExperience resort-like amenities that make Allegro the best choice for comfortable living. Take advantage of our sparkling pools, a state-of-the-art fitness center, and a cozy clubhouse for gatherings. Each apartment features modern finishes and conveniences such as dishwashers and private balconies, making it easy to unwind after a busy day at the nearby college. Make Allegro your home base and enjoy the vibrant community and stress-free commute to class.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Mountain Community College",
      "seo_description": "Find your ideal home at Allegro, near South Mountain Community College in Ahwatukee. Experience vibrant living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "apartments-near-protea-medical-center-ahwatukee",
      "search_query": "apartments near Protea Medical Center Ahwatukee Foothills",
      "category": "Hospital",
      "h1_title": "Apartments Near Protea Medical Center",
      "h2_subtitle": "Live conveniently near Protea Medical Center in Ahwatukee Foothills at Allegro, offering quality apartments with modern amenities.",
      "page_copy": "Welcome to Allegro, where you can find ideal apartments near Protea Medical Center in the serene Ahwatukee Foothills. Our community is perfect for healthcare professionals and anyone seeking the convenience of nearby medical facilities while enjoying a tranquil residential environment. Choose from our range of one, two, and three-bedroom layouts, designed with modern finishes and ample natural light.\n\nAt Allegro, enjoy amenities that enhance your living experience, including refreshing pools, a modern fitness center, and a welcoming clubhouse. Each apartment is equipped with necessities like dishwashers and private patios or balconies, offering comfortable and practical living spaces. With its proximity to Protea Medical Center and surrounding amenities, Allegro provides the perfect blend of accessibility and serenity in Phoenix, AZ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Protea Medical Center",
      "seo_description": "Discover Allegro, offering apartments near Protea Medical Center in Ahwatukee Foothills. Enjoy modern amenities and serene living close to work.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "apartments-close-to-banner-health-clinic-phoenix",
      "search_query": "apartments close to Banner Health Clinic Phoenix AZ",
      "category": "Hospital",
      "h1_title": "Apartments Close to Banner Health Clinic",
      "h2_subtitle": "Discover Allegro, offering apartments close to Banner Health Clinic in Phoenix, AZ with top-notch amenities and comfortable living spaces.",
      "page_copy": "Allegro presents ideal living opportunities with apartments close to Banner Health Clinic in Phoenix, AZ. This prime location caters to medical professionals and anyone desiring proximity to healthcare services, while enjoying a vibrant and welcoming community. Choose from our spacious one, two, and three-bedroom apartments, all brimming with natural light and modern finishes.\n\nLiving at Allegro means indulging in extensive amenities like sparkling pools, a cutting-edge fitness center, and a community-focused clubhouse. Our thoughtfully designed apartments, with features like dishwashers and private patios or balconies, offer a perfect retreat from your busy day. Allegro's convenient location near Banner Health Clinic, complemented by a lively neighborhood, provides the ideal setting for professional and personal fulfillment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Banner Health Clinic",
      "seo_description": "Find beautiful Allegro apartments close to Banner Health Clinic in Phoenix. Enjoy modern amenities and easy access to healthcare services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "apartments-near-south-mountain-park-phoenix",
      "search_query": "apartments near south mountain park phoenix",
      "category": "Park",
      "h1_title": "Apartments Near South Mountain Park",
      "h2_subtitle": "Explore Allegro, offering beautiful apartments near South Mountain Park in Phoenix. Enjoy nature and modern living at its best.",
      "page_copy": "Nestled in the vibrant city of Phoenix, Allegro offers beautiful living options with apartments near South Mountain Park. This location is ideal for outdoor enthusiasts and those who appreciate the stunning natural landscapes of the area. Our community provides a range of one, two, and three-bedroom apartments designed with contemporary finishes and ample natural sunlight.\n\nEnjoy the best of outdoor and urban living with Allegro's exceptional amenities, including sparkling pools, a fully-equipped fitness center, and a social clubhouse. Each apartment comes with conveniences like dishwashers and private patios or balconies, creating a peaceful retreat after a day of hiking or exploring South Mountain Park. With its prime location and luxurious comfort, Allegro makes the perfect home for nature lovers and city dwellers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Mountain Park Phoenix",
      "seo_description": "Discover Allegro's apartments near South Mountain Park in Phoenix. Enjoy modern amenities and easy access to nature and city living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166423",
      "source": "generator",
      "page_item_url": "apartments-close-to-desert-breeze-park-maricopa",
      "search_query": "apartments close to desert breeze park maricopa county",
      "category": "Park",
      "h1_title": "Apartments Close to Desert Breeze Park",
      "h2_subtitle": "Live near Desert Breeze Park in Maricopa County at Allegro. Our apartments offer comfort and seamless access to nature and recreation.",
      "page_copy": "Experience the perfect blend of convenience and leisure at Allegro, offering apartments close to Desert Breeze Park in Maricopa County. This location is ideal for those who love outdoor activities, family outings, or peaceful afternoons in nature. Our community features well-appointed one, two, and three-bedroom apartments filled with natural light and modern design elements.\n\nAllegro provides an array of resort-style amenities to enhance your living experience, featuring refreshing pools, an advanced fitness center, and a community-centric clubhouse. Each apartment is designed with functionality in mind, offering dishwashers, private patios or balconies, and ample storage. Embrace the tranquility of living near Desert Breeze Park while enjoying the vibrant offerings of Phoenix at Allegro, your new home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
      "featured_image_media": {
        "alt_text": "Allegro Luxury Apartments monument sign and leasing office exterior at dusk.",
        "public_id": "019d02c7-2889-70a9-b2bf-54fb6e9f7d57",
        "storage_key": "property/6767906449166423/019d02c7-2889-70a9-b2bf-54fb6e9f7d57.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Desert Breeze Park",
      "seo_description": "Find Allegro apartments close to Desert Breeze Park, Maricopa County. Enjoy modern amenities and easy park access in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5293"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104424914"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=99a07488e80a26a8277636f55490effeb95b4d116261604a9893001a0dbd6b7872e7b8943ecc6545b942a42c52819aba\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KRPJ2GNG"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "218ALE"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40243710832"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Allegro Luxury Apartments/scheduletourwidget/uyKoarbpe2G6c2FYyf/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjM0UW5PSHdaV0ZoKzZGNXNjUy9EZXc9PSIsInZhbHVlIjoiRUFwSzNMQk50QTdhVzlsY205RC8xQT09IiwibWFjIjoiMjIxZjIxOGYwZDI4ZTRiMjBlMWMxOThjYjZmOWYyZDRkOTYzZDQzMWQzNzc5YTBmNzIwMWExM2NmYmVhNGNiYiJ9"
    }
  ],
  "custom_qb_id": "5293",
  "custom_repli_id": "18104424914",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=99a07488e80a26a8277636f55490effeb95b4d116261604a9893001a0dbd6b7872e7b8943ecc6545b942a42c52819aba\"></script>",
  "custom_google_gtm_id": "GTM-KRPJ2GNG",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "218ALE",
  "custom_hubspot_company_id": "40243710832",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Allegro Luxury Apartments/scheduletourwidget/uyKoarbpe2G6c2FYyf/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjM0UW5PSHdaV0ZoKzZGNXNjUy9EZXc9PSIsInZhbHVlIjoiRUFwSzNMQk50QTdhVzlsY205RC8xQT09IiwibWFjIjoiMjIxZjIxOGYwZDI4ZTRiMjBlMWMxOThjYjZmOWYyZDRkOTYzZDQzMWQzNzc5YTBmNzIwMWExM2NmYmVhNGNiYiJ9",
  "custom_audioeye_site_id": "f64b3400-497b-4dc2-a219-3a3c5a0c9322",
  "custom_audioeye_site_hash": "41c1bab110d6c1fcbe5b21d09b3eedff"
};

export const generatedAt = '2026-08-21T22:01:02.777Z';
